var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26552 9.5C4.53403 9.5 3.13037 10.8431 3.13037 12.5V20.5C3.13037 22.1569 4.53403 23.5 6.26552 23.5H18.8061C20.5376 23.5 21.9413 22.1569 21.9413 20.5V12.5C21.9413 10.8431 20.5376 9.5 18.8061 9.5C18.8061 7.91824 18.5353 5.97827 17.6335 4.39615C16.695 2.74981 15.0643 1.5 12.5358 1.5C10.0073 1.5 8.37664 2.74981 7.43818 4.39615C6.53632 5.97827 6.26552 7.91824 6.26552 9.5ZM6.26552 11.5C5.68836 11.5 5.22047 11.9477 5.22047 12.5V20.5C5.22047 21.0523 5.68836 21.5 6.26552 21.5H18.8061C19.3833 21.5 19.8512 21.0523 19.8512 20.5V12.5C19.8512 11.9477 19.3833 11.5 18.8061 11.5H6.26552ZM9.27307 5.35385C8.60734 6.52173 8.35562 8.08176 8.35562 9.5L16.716 9.5C16.716 8.08176 16.4643 6.52173 15.7986 5.35385C15.1695 4.25019 14.1875 3.5 12.5358 3.5C10.8841 3.5 9.90218 4.25019 9.27307 5.35385Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockX2);
export default __webpack_public_path__ + "static/media/LockX2.b8d7330c98c4032d33c67300bf0325e0.svg";
export { ForwardRef as ReactComponent };